import { css, type Theme } from "@emotion/react";

export const container = (theme: Theme) => css`
  display: flex;
  justify-content: flex-start;
  align-content: flex-end;

  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 2rem;
  color: ${theme.success.textBase};

  &:hover {
    background-color: ${theme.system.backgroundMutedHover};
  }
`;

export const text = css`
  margin-right: 1rem;

  &&& {
    margin-bottom: 0;
  }
`;

export const arrow = css`
  align-self: center;
`;

export const highlightRow = (theme: Theme) => css`
  background-color: ${theme.system.backgroundMutedHover};
`;
